import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Value } from "./Value";

export const TotalDueLine = Object.assign(
  () => (
    <>
      <Typography.LabelMd weight="semibold">
        {t("paywall_checkout.amount_due")}
      </Typography.LabelMd>
      <Value />
    </>
  ),
  {
    Value,
  },
);
